import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'player-age-filter',
    templateUrl: './player-age-filter.modal.html',
    styleUrls: ['./player-age-filter.modal.scss'],
})
export class PlayerAgeFilterModal implements OnInit{
    
    @Input() minAge: number;

    @Input() maxAge: number;

    readonly minAgeValue: number = 16;

    readonly maxAgeValue: number = 50;

    formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal) {}
    
    ngOnInit(): void {
        this.formGroup = new FormGroup({
            minValueFormControl: new FormControl(),
            maxValueFormControl: new FormControl()
        })
    }

   

    submit() {
        let result: any = {
            minAge: null,
            maxAge: null
        }

        if (this.formGroup.controls.minValueFormControl.value) {
            var minAge = parseInt(this.formGroup.controls.minValueFormControl.value);

            if (!minAge)
                return;

            if (minAge < this.minAgeValue) 
                minAge = this.minAgeValue;

            result.minAge = minAge;
        }
        

        if (this.formGroup.controls.maxValueFormControl.value) {
            var maxAge = parseInt(this.formGroup.controls.maxValueFormControl.value);

            if (!maxAge)
                return;

            if (maxAge > this.maxAgeValue) 
                maxAge = this.maxAgeValue;

            result.maxAge = maxAge;
        }
        

        this.activeModal.close(result);
    }
}